import type { Metric } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (typeof onPerfEntry === 'function') {
    import('web-vitals').then(({ getCLS, getFCP, getLCP, getTTFB, getFID }) => {
      getCLS(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
      getFID(onPerfEntry);
    });
  }
};

export default reportWebVitals;
